import * as React from "react";
import {InputHTMLAttributes} from "react";
import {Field} from 'redux-form'
import IFormInputs from "./IFormInputs";
import InputRenderer from "../formrenderers/InputRenderer";
import Required from "../validations/Required";

export interface IChecboxInputProps extends IFormInputs, InputHTMLAttributes<HTMLInputElement> {
}

export default (props: IChecboxInputProps) => {
    const { inputID, label = null, ...rest } = props;
    return (
        <Field name={inputID} label={label} type="checkbox" component={InputRenderer} validate={[Required]} {...rest} />
    );
}